import {
  base_colorAction,
  base_colorContentBorder,
  base_colorRaisedSurface,
  base_colorSurfaceSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  min-height: ${spacing(87.5)};
  padding: ${spacing(9)} ${spacing(10)};
  overflow: hidden;
  color: inherit;
  font: inherit;
  text-align: left;
  background-color: ${base_colorRaisedSurface};
  border: 1px solid ${base_colorContentBorder};
  border-radius: ${spacing(2)};
  box-shadow: none;
  transition: border-color 150ms ease-out;

  &.interactive {
    cursor: pointer;
  }

  &.interactive:hover {
    border-color: ${base_colorAction};
  }

  &.interactive:focus-visible {
    border-color: ${base_colorAction};
    outline: 2px solid ${base_colorAction};
    outline-offset: 2px;
  }

  &.disabled {
    cursor: default;
    background-color: ${base_colorSurfaceSecondary};
  }
`
